import { render, staticRenderFns } from "./resultado-clasificador.vue?vue&type=template&id=4279e9ae&"
import script from "./resultado-clasificador.component.ts?vue&type=script&lang=ts&"
export * from "./resultado-clasificador.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports